module.exports = __webpack_public_path__ + "images/avatars/female/18.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/18.png
// module id = LT8D
// module chunks = 154